/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  users: [],
  formateurs: [],
  formateur: [],
  groupes: [],
  seances: [],
  candidats:[],
  documents:[],
  bilan_c:[],
  bilan_f:[],
}
